import { render, staticRenderFns } from "./LogoLinkedinSvg.vue?vue&type=template&id=6fba66e8"
import script from "./LogoLinkedinSvg.vue?vue&type=script&lang=js"
export * from "./LogoLinkedinSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports